import { FC, useCallback } from 'react'
import { ColorOptions } from '../../theme/UiThemeProvider'
import { Box } from '../BoxNew'
import { Icon, IconIds } from '../IconNew'
import { Spacer } from '../Spacer'
import { Text } from '../TextNew'
import textLabelTypes from './TextLabelTypes'

function isURLFontIcon(url: string): boolean {
  let isFontIcon = false
  const icons = Object.keys(IconIds)
  icons.forEach((icon) => {
    if (IconIds[icon as keyof typeof IconIds] === url) {
      isFontIcon = true
    }
  })
  return isFontIcon
}
export interface TextLabelProps {
  title?: string
  subTitle?: string
  type: keyof typeof textLabelTypes | Array<keyof typeof textLabelTypes>
  bgColor?: string
  fontColor: ColorOptions | Array<ColorOptions>
  selected?: boolean
  selectable?: boolean
  onSelected?: (selection: boolean) => void
}

const TextLabel: FC<TextLabelProps> = ({
  title,
  subTitle,
  type,
  bgColor,
  fontColor,
  selected,
  selectable = false,
  onSelected,
}: TextLabelProps) => {
  const updateSelction = useCallback(() => {
    if (onSelected) {
      onSelected(true)
    }
  }, [onSelected])

  return (
    <Box {...[textLabelTypes[type as keyof typeof textLabelTypes].topContainer]}>
      {title && !isURLFontIcon(title) && (
        <Box
          {...[
            textLabelTypes[type as keyof typeof textLabelTypes].border,
            { backgroundColor: bgColor },
            type === 'RoundEdgedLabel'
              ? {
                  borderColor: selected ? 'PRIMARY' : fontColor,
                  backgroundColor: selected ? 'PRIMARY' : bgColor,
                }
              : {},
          ]}
          onPress={
            type === 'RoundEdgedLabel' && selectable && !selected
              ? () => {
                  updateSelction()
                }
              : () => null
          }>
          <Text
            title={title}
            type="body14"
            // type={type === 'WithBgRightRounded' ? TextTypes.H_FS12_FW_500 : TextTypes.H2_BOLD_CENTER}
            color={selected ? 'WHITE' : fontColor}
          />
        </Box>
      )}

      {type === 'WithStrike' && title && <Box {...textLabelTypes[type as keyof typeof textLabelTypes].strikerStyle} />}
      {type === 'MapLabel' && title && <Box {...textLabelTypes[type as keyof typeof textLabelTypes].arrow} />}
      {title && isURLFontIcon(title) && <Icon id={title as any} color={'WHITE'} size="FONT_SIZE_SMALL" />}

      {type === 'WithBg' && subTitle && (
        <>
          <Spacer direction="horizontal" size="SMALL" />
          <Text title={subTitle} type="titleBold18" color={title ? 'WHITE_30' : 'WHITE'} />
        </>
      )}
    </Box>
  )
}
export { textLabelTypes, TextLabel }
